import React from 'react'
import { HiOutlineVariable } from 'react-icons/hi'

export default function VariableInput({ template, values, onChange }) {
  // Extract variables from template content
  const extractVariables = (content) => {
    const matches = content.match(/\{\{(\w+)\}\}/g)
    if (!matches) return []
    return [...new Set(matches.map(match => match.replace(/[{}]/g, '')))]
  }
  
  const detectedVariables = extractVariables(template?.content || '')
  
  if (detectedVariables.length === 0) {
    return (
      <div className="bg-gradient-to-br from-white to-gray-50/50 shadow-2xl rounded-2xl p-8 border border-gray-200/50 h-fit sticky top-20 backdrop-blur-sm">
        <h3 className="text-base font-bold text-gray-900 mb-6 flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-xl flex items-center justify-center shadow-lg">
            <HiOutlineVariable className="w-5 h-5 text-white" />
          </div>
          変数入力
        </h3>
        <div className="text-center py-12">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-100 to-indigo-100 rounded-full blur-2xl opacity-50"></div>
            <svg className="relative w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <p className="text-sm text-gray-600 mb-3 font-medium">
            このテンプレートには変数が含まれていません
          </p>
          <p className="text-xs text-gray-400 leading-relaxed">
            テンプレート内で <code className="bg-gray-100 px-2 py-1 rounded text-purple-600 font-mono">{`{{変数名}}`}</code> を使用すると<br />
            ここに入力欄が表示されます
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-gradient-to-br from-white to-gray-50/50 shadow-2xl rounded-2xl p-8 border border-gray-200/50 h-fit sticky top-20 backdrop-blur-sm">
      <h3 className="text-base font-bold text-gray-900 mb-6 flex items-center gap-3">
        <div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-xl flex items-center justify-center shadow-lg">
          <HiOutlineVariable className="w-5 h-5 text-white" />
        </div>
        変数入力
        <span className="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded-full font-medium">{detectedVariables.length}個</span>
      </h3>
      
      <div className="space-y-4">
        {detectedVariables.map((variableName, index) => (
          <div key={variableName} className="group">
            <label 
              htmlFor={variableName}
              className="flex items-center gap-2 text-sm text-gray-700 font-semibold mb-2"
            >
              <div className="w-6 h-6 bg-gradient-to-r from-blue-100 to-purple-100 rounded-lg flex items-center justify-center text-xs font-bold text-purple-600">
                {index + 1}
              </div>
              {variableName}
            </label>
            <div className="relative">
              <input
                type="text"
                id={variableName}
                value={values[variableName] || ''}
                onChange={(e) => onChange(variableName, e.target.value)}
                className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-purple-400 focus:ring-4 focus:ring-purple-100 transition-all duration-200 text-sm placeholder-gray-400 group-hover:border-gray-300"
                placeholder={`${variableName}を入力してください`}
                autoComplete="off"
              />
              {values[variableName] && (
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border border-blue-100/50">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-sm text-gray-700 font-medium mb-1">リアルタイムプレビュー</p>
            <p className="text-xs text-gray-500 leading-relaxed">
              変数を入力すると右側のメールプレビューに即座に反映されます
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}